import './public-path';
import Vue from 'vue';
import appConfig from 'common/config';
import { Dialog, Button } from 'vant';
import { getHostApp, initMicroApp } from '@mtfe/cdb-microx';
import MTD from '@ss/mtd-vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import '@ss/mtd-vue/lib/theme2/index.css';

Vue.use(MTD);

Vue.use(Button);
Vue.use(Dialog);

if (!appConfig.isLocal) {
  Vue.config.productionTip = false;
}

let qiankun: QiankunLifeCycle | null = null;
let microApp: any = {
  bootstrap: null,
  mount: null,
  unmount: null,
};

if (!(window as any).__POWERED_BY_QIANKUN__) {
  new Vue({
    router: router.getRouterInstance(),
    render: (h: any) => h(App),
  }).$mount('#app');
} else {
  qiankun = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async bootstrap(props: BootstrapProps) {
      const { pluginStore } = getHostApp();
      const Request = pluginStore.get('Request');
      // 可在此注册axios hook
      Vue.prototype.$request = new Request({});
    },
  };
  microApp = initMicroApp(qiankun, {
    Vue,
    App,
    store,
    router,
    mountId: '#app',
    appConfig,
    // 参数为 { title, message }
    showErrorUtil: Dialog,
    // afterMount
    afterMount() {
    },
  });
}

export const bootstrap = microApp.bootstrap;

export const mount = microApp.mount;

export const unmount = microApp.unmount;
